module.exports = __webpack_public_path__ + "img/Alchimeia.50881b1b.png";